module.exports = __webpack_public_path__ + "static/media/zeroes.eab09505.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/zeroes.png
// module id = 70
// module chunks = 0